import { Package } from 'lucide-react';
import { EmptyState } from '@ideoz/ui/components/molecules/EmptyState';

export function ArtifactsEmptyState(): JSX.Element {
  return (
    <EmptyState
      title="Nothing to see here yet"
      description="Generate an artifact from a conversation and it will appear here."
    />
  );
}
